import { ITemplateGuestRenterMails } from 'modules/_common/models';
import API from 'services/api';

export const getMailTaskGuestRenterMails = ({
  calculationId,
}: {
  calculationId: string;
}): Promise<ITemplateGuestRenterMails> =>
  API.get(`/api/accommodation/templates/calculations/${calculationId}/emails`)?.then(
    res => res?.data,
  );
